import { ScaleLinear } from 'd3-scale';
import { percentageFormat } from 'utils/components/TimeSeriesChart/yAxis';
import { deriveYAxisLabelProps } from '../axisLabel/deriveLabelProps';
import { YAxisLabelProps } from '../axisLabel/YAxisLabel';
import {
    minParticipationRateTooltip,
    maxParticipationRateTooltip,
} from './help/percentageOfMarketVolumeLegendTooltips';

export function derivePercentageOfMarketYAxisLabelProps(
    minParticipationRate: number | undefined,
    maxParticipationRate: number | undefined,
    yScale: ScaleLinear<number, number>,
    height: number,
    width: number
): Record<
    'minParticipationRate' | 'maxParticipationRate',
    YAxisLabelProps | undefined
> {
    return deriveYAxisLabelProps(
        [
            {
                key: 'minParticipationRate',
                type: 'Min',
                tooltip: minParticipationRateTooltip,
                value: minParticipationRate,
            },
            {
                key: 'maxParticipationRate',
                type: 'Max',
                tooltip: maxParticipationRateTooltip,
                value: maxParticipationRate,
            },
        ],
        percentageFormat,
        yScale,
        height,
        width
    );
}
